import { useEffect, useState } from "react";

import { cookieConsentContext } from "@context/Contexts";
import { CookieConsentContextType } from "@typing/State";
import { initializeCookieConsentBanner } from "@utils/cookieUtils";

import "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";

declare global {
  interface Window {
    CookieConsentApi: any;
  }
}

type Props = React.PropsWithChildren<{}>;

const CookieConsentProvider = ({ children }: Props) => {
  const defaultStatus: CookieConsentContextType = {
    acceptsAnalyticsCookies: import.meta.env.VITE_ACCEPT_ALL_COOKIES ? true : null,
    acceptsFunctionalCookies: import.meta.env.VITE_ACCEPT_ALL_COOKIES ? true : null,
    acceptsNecessaryCookies: import.meta.env.VITE_ACCEPT_ALL_COOKIES ? true : null,
    acceptsPaymentCookies: import.meta.env.VITE_ACCEPT_ALL_COOKIES ? true : null
  };

  const [status, setStatus] = useState<CookieConsentContextType>(defaultStatus);

  useEffect(() => {
    initializeCookieConsentBanner(setStatus);
  }, []);

  return <cookieConsentContext.Provider value={status}>{children}</cookieConsentContext.Provider>;
};

export default CookieConsentProvider;
